import { Transition } from "components/animations/Transition";
import * as React from "react";
import { config } from "react-spring";

interface Props {
  children: React.ReactNode;
}
const TabContainer: React.FC<Props> = ({ children }) => {
  return (
    <Transition
      settings={{
        from: { opacity: 0.8 },
        enter: { opacity: 1 },
        config: { ...config.default, precision: 0.01 },
      }}
    >
      <div className="bg-white relative">{children}</div>
    </Transition>
  );
};

export default TabContainer;
